// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
export type AstatDailyMovementFragmentFragment = { __typename?: 'AstatDailyMovementProtoDTO', date: LocalDate, occupiedUnits: number, open: boolean, totalArrivals: number, totalDepartures: number, totalGuestsPresent: number };

export const AstatDailyMovementFragmentFragment = gql`
    fragment AstatDailyMovementFragment on AstatDailyMovementProtoDTO {
  date
  occupiedUnits
  open
  totalArrivals
  totalDepartures
  totalGuestsPresent
}
    `;
/* eslint-enable */